import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

import useStateRef from 'react-usestateref';
import toast, { Toaster } from 'react-hot-toast';
import swal from 'sweetalert';

import config from "../../../config/config";
import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";
import { Pagination } from "@mui/material";
import Select from 'react-select';


const TableData = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [Search, setSearch, SearchRef] = useStateRef('');

  const [nopage, setnopage, nopageRef] = useStateRef();
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();


  const [wastetable, setWasteTable] = useState([]);
  const [wtable, setWtable] = useState([])
  const [shouldShowSelect, setShouldShowSelect] = useState(false)

  const [selectedProduct, setSelectedProduct, selectedProductRef] = useStateRef('');
  const [selectedSubProduct, setSelectedSubProduct, selectedSubProductRef] = useStateRef('');

  
  const [prodlist, setProdlist, prodlistRef] = useStateRef([]);
  const [subprodlist, setSubProdlist, subprodlistRef] = useStateRef([]);
  const [ttypelist, setTtypelist, ttypelistRef] = useStateRef([]);

  const [wid, setWid, widRef] = useStateRef('');
  const [touch, setTouch, touchRef] = useStateRef('');
  const [size, setSize, sizeRef] = useStateRef('');
  const [fmwt, setFmwt, fmwtRef] = useStateRef("");
  const [twt, setTwt, twtRef] = useStateRef('');
  const [wper, setWper, wperRef] = useStateRef('');
  const [mper, setMper, mperRef] = useStateRef("");
  const [mgm, setMgm, mgmRef] = useStateRef('');
  const [mvalu, setMvalu, mvaluRef] = useStateRef('');

  const [resultss, setResultss, resultssRef] = useStateRef();
  
  const [errors, setErrors] = useState({});

  const [sstatement, setSstatement, sstatementRef] = useStateRef();

  const [shouldShow, setShouldShow] = useState(false)

  const notify1 = () => toast.success('Successfully Deleted.');
  const notify2 = () => toast.error("Not able to Delete");

  useEffect(() => {
    getWastetable(1)
    loadData()
  }, []);

  async function loadData() {
    try {
      await getproductlist()
      await getTagTypelist()
    } catch (error) {
      console.error("API call error1:", error);
    }
  }

  async function loadData2() {
    try {
      await getsubproductlist()
    } catch (error) {
      console.error("API call error2:", error);
    }
  }

  const SubProductPg = (event, value) => {
    getWastetable(value);
   };

   
  async function getWastetable(page) {
    try {

      let postData = {
        PageNumber: String(page),
        RowspPage: config.pageCount,
        Search:SearchRef.current
      }

      let results = await apiService.postCall(apiPath.master.get.getWasteTable,postData);
      if (results != "-1") {
        setWtable(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getproductlist() {
    try {
      let results = await apiService.getproductlist(apiPath.master.get.getproductlist);
      if (results != "-1") {
        setProdlist(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function getsubproductlist() {
    try {
      let postData = {
        prodcode: Number(selectedProductRef.current)
      }
      let results = await apiService.getsubproductlist(apiPath.master.get.getsubproductlist, postData);
      if (results != "-1") {
        if (results.data[0].length > 0) {
          setSubProdlist(results.data[0])
          setShouldShow(true)
        } else {
          setShouldShow(false)
        }
        ;
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getTagTypelist() {
    try {
      let results = await apiService.getTagTypelist(apiPath.master.get.getTagTypelist);
      if (results != "-1") {
        console.log("setTtypelist", results.data[0]);
        setTtypelist(results.data[0]);
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function insertUpdateWaste() {
    try {
      let postData = {
        "wid": Number(widRef.current),
        "fromWt": Number(fmwtRef.current),
        "toWt": Number(twtRef.current),
        "wastePer": Number(wperRef.current),
        "mcPer": Number(mperRef.current),
        "mcGram": Number(mgmRef.current),
        "mcValue": Number(mvaluRef.current),
        "sizeCode": Number(0),
        "touch": Number(touchRef.current),
        "procode": Number(selectedProductRef.current),
        "subCode": Number(selectedSubProductRef.current),
        "StatementType": String(sstatementRef.current)
      }
      console.log("postdata", postData);
      let results = await apiService.insertUpdateWaste(apiPath.master.insertUpdate.insertUpdateWaste, postData);
      if (results != "-1") {
        setResultss(results)
        getWastetable(currentpgRef.current);
        console.log(results, "result insert");
      }
    } catch (e) {
      console.log(e);
    }

  }

  const SubmitCall = () => {

    try {
      const isFormValid = validateForm();
      if (isFormValid) {
        insertUpdateWaste();
        swal({
          title: "Success",
          text: "Successfully Added",
          icon: "success",
          button: "Ok"
        }).then(function () {
          setShow1(false);
          getWastetable(currentpgRef.current);
        });
      }

    } catch (e) {
      console.log(e);

    }
  }

  const handleClose1 = () => {
    setShow1(false)
    setErrors(true)
  }

  const handleShow1 = (type, id, product, subprod, touch,
    size, fmwt, twt, wper, mper, mgm, mvalu, statemente, show) => {

  

    setWid(id);
    setFmwt(fmwt);
    setTwt(twt);
    setWper(wper);
    setMper(mper);
    setMgm(mgm);
    setMvalu(mvalu);
    setSize(size);
    setTouch(touch);
    setSelectedProduct(product);

    setSstatement(statemente);
    setShouldShowSelect(true)

    if (statemente == 'Delete') {
      insertUpdateWaste();
      if (resultssRef.current != "-1") {
        notify1();
        getWastetable(currentpgRef.current);
      }
      else {
        notify2();
      }
    }

    if (type == 1) {
      setSho('Add New');
      setShow('Save');
      setSelectedProduct(" ")

      setSelectedSubProduct(" ");
      setShouldShow(true)


    } else if (type == 2) {
      loadData2()
      setSho('Edit');
      setShow('Update');
      setShouldShowSelect(true)
      setShouldShow(true)
      setSelectedSubProduct(subprod);
    }

    setShow1(show);
  }

  const handleProductChange = event => {
    setSelectedProduct(event.value);
    clearError('selectedProduct')
    loadData2()
  };

  const handleSubProductChange = event => {
    setSelectedSubProduct(event.value);
    clearError('selectedSubProduct')
  };

  const notifyError = (fieldName) => {
    toast.error(`${fieldName} is a mandatory field and must be filled in.`);
  };


  const validateForm = () => {
    const newErrors = {};

    if (typeof selectedProduct === 'string' && !selectedProduct.trim()) {
      newErrors.selectedProduct = '*Please select a product';
    }

    if (typeof selectedSubProduct === 'string' && !selectedSubProduct.trim()) {
      newErrors.selectedSubProduct = '*Please select a sub product';
    }

    if (typeof touch === 'string' && !touch.trim()) {
      newErrors.touch = '*Please select a touch';
    }

    if (typeof fmwt === 'string' && !fmwt.trim()) {
      newErrors.fmwt = true;
      notifyError('From Wt');
    }
    if (typeof twt === 'string' && !twt.trim()) {

      newErrors.twt = true;
      notifyError('To Wt');
    }
    if (typeof wper === 'string' && !wper.trim()) {
      newErrors.wper = true;
      notifyError('Waste %');
    }

    if (typeof mper === 'string' && !mper.trim()) {
      newErrors.mper = true;
      notifyError('Mc %');
    }

    if (typeof mgm === 'string' && !mgm.trim()) {
      newErrors.mgm = true;
      notifyError('Mc/Gram');
    }

    if (typeof mvalu === 'string' && !mvalu.trim()) {
      newErrors.mvalu = true;
      notifyError('Mc Amount');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (fieldName) => {
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: undefined }));
  };

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Waste Table details.</h4>
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                />
              </div>
              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                  <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                       setcurrentpg(1)
                       getWastetable(currentpgRef.current)}}>
                 <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>

              <div className="col d-flex justify-content-end">
                <Button className="text-center btn-primary btn-icon btn-sm mt-lg-0 mt-md-0 mt-3 "
                  onClick={() => { handleShow1(1, "", "", " ", " ", " ", " ", " ", " ", " ", " ", " ", "Insert", true) }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>

                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Waste Table</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-3">
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-12 col-lg-12'>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <Form.Label>Product <span className="text-danger">*</span></Form.Label>
                                  <Select className="" id="product" 
                             options={prodlist}
                             value={prodlist.filter(function(option) {
                              return option.value === selectedProduct;
                            })}
                            onChange=
                            {
                              (e) => {

                                handleProductChange(e);
                                
                              }
                              }
                             >

                             </Select>
                        
                                  {errors.selectedProduct && <div className="invalid-feedback">{errors.selectedProduct}</div>}
                                </div>
                              </div>
                            </div>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-12'>
                                  <Form.Label>Sub Product <span className="text-danger">*</span></Form.Label>
                                  <Select className="" id="subproduct" 
                             options={subprodlist}
                             value={subprodlist.filter(function(option) {
                              return option.value === selectedSubProduct;
                            })}
                            onChange=
                            {
                              (e) => {

                                handleSubProductChange(e);
                                
                              }
                              }
                             >

                             </Select>
                            
                                  {errors.selectedSubProduct && <div className="invalid-feedback">{errors.selectedSubProduct}</div>}
                                </div>
                              </div>
                            </div>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-6'>
                                  <Form.Label>Touch. <span className="text-danger">*</span></Form.Label>
                                  {
                                    shouldShowSelect ? (
                                      <select
                                        className={`form-select ${errors.touch ? 'is-invalid' : ''}`}
                                        id='Touch'
                                        value={touch}
                                        onChange={(e) => {
                                          try {
                                            setTouch(e.target.value)
                                            if (touchRef.current == "") {
                                              setTouch('');
                                              setSize('');
                                        
                                            } else {
                                              let res = ttypelist.filter((item) => item.Code == e.target.value);
                                              setTouch(res[0].Code);
                                              setSize(res[0].Purity);
                                              clearError('touch')
                                            }
                                          } catch (e) {
                                            console.log(e);
                                          }

                                        }}
                                        isInvalid={errors.touch ? 'invalid' : ''}
                                      >
                                        <option value="" >TOUCH</option>
                                        {ttypelist.map((ttypelist) => (
                                          <option key={ttypelist.Code} value={ttypelist.Code}>{ttypelist.TagType}</option>
                                        ))}
                                      </select>
                                    )
                                      :
                                      (
                                        <select className="form-select" id='Touch' value={touch} onChange={(e) => { 
                                          let res = ttypelist.filter((item) => item.Touch == e.target.value);
                                          setTouch(res[0].Touch);
                                          setSize(res[0].Purity);
                                        }
                                        } disabled={widRef.current != 0 ? false : false}>
                                        
                                          {ttypelist.map((ttypelist) => (
                                            <option key={ttypelist.Code} value={ttypelist.Code}>{ttypelist.TagType}</option>
                                          ))}
                                        </select>
                                      )
                                  }
                                  {errors.touch && <div className="invalid-feedback">{errors.touch}</div>}
                                </div>
                                <div className='col-md-6'>
                                  <Form.Label>Size <span className="text-danger">*</span></Form.Label>
                                  <Form.Control type="text" id='Size' value={size} disabled={widRef.current != 0 ? true : false} />
                                </div>
                              </div>
                            </div>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-3'>
                                  <Form.Label>From Wt. <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='fwt'
                                    value={fmwt}
                                    onChange={(e) => {
                                      setFmwt(e.target.value)
                                      clearError('fmwt')
                                    }}
                                    isInvalid={!!errors.fmwt} />
                                </div>
                                <div className='col-md-3'>
                                  <Form.Label>To Wt. <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='twt'
                                    value={twt}
                                    onChange={(e) => {
                                      setTwt(e.target.value)
                                      clearError('twt')
                                    }}
                                    isInvalid={!!errors.twt} />
                                </div>
                                <div className='col-md-3'>
                                  <Form.Label>Waste %. <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='wastper'
                                    value={wper}
                                    onChange={(e) => {
                                      setWper(e.target.value)
                                      clearError('wper')
                                    }}
                                    isInvalid={!!errors.wper} />
                                </div>
                                <div className='col-md-3'>
                                  <Form.Label>Mc % <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='mcper'
                                    value={mper}
                                    onChange={(e) => {
                                      setMper(e.target.value)
                                      clearError('mper')
                                    }}
                                    isInvalid={!!errors.mper} />
                                </div>
                              </div>
                            </div>

                            <div className='mb-3'>
                              <div className='row'>
                                <div className='col-md-4'>
                                  <Form.Label>Mc/Gram. <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='mcgrm'
                                    value={mgm}
                                    onChange={(e) => {
                                      setMgm(e.target.value)
                                      clearError('mgm')
                                    }}
                                    isInvalid={!!errors.mgm} />
                                </div>
                                <div className='col-md-6'>
                                  <Form.Label>Mc Amount <span className="text-danger">*</span></Form.Label>
                                  <Form.Control
                                    type="number"
                                    id='mcvalue'
                                    value={mvalu}
                                    onChange={(e) => {
                                      setMvalu(e.target.value)
                                      clearError('mvalu')
                                    }}
                                    isInvalid={!!errors.mvalu} />
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" onClick={() => {
                        SubmitCall()
                      }}
                        disabled={shouldShow ? false : true}
                      >{show}
                      </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
                <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"

                >
                  <thead>
                    <tr>
                      <th>ProdName</th>
                      <th>ItemName</th>
                      <th>FromWt</th>
                      <th>ToWt</th>
                      <th>WastePer</th>
                      <th>McPer</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {wtable.map((item) => (
                      <tr>
                        <td>{item.ProdName}</td>
                        <td>{item.ShortName}</td>
                        <td>{item.Fromwt}</td>
                        <td>{item.ToWt}</td>
                        <td>{item.WastePer}</td>
                        <td>{item.McPer}</td>
                        <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#"
                            onClick={() => { handleShow1(2, item.Id, item.ProdCode, item.SubCode, item.Touch, item.SizeCode, item.Fromwt, item.ToWt, item.WastePer, item.McPer, item.McGram, item.McValue, "Update", true) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
                        <td>
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete User" to="#"
                            onClick={() => { handleShow1(3, item.Id, "", "", "", "", "", "", "", "", "", "", "Delete", false) }}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </Table>
                <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>
                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>
                  <div>
                    <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={SubProductPg} />
                  </div>
                </div>

              </div>
              {/* 
              {nodata &&
                <div>
                  <h6 className='mb-0 mt-3' style={{ textAlign: 'center' }}>No Data Available</h6>
                </div>
              } */}

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
